class CustomList {
  constructor({ pid, cid, sortType }) {
    this.baseUrl = 'https://sw.ahaselected.com/aha-web';
    this.url = {
      productList: '/landing/rec/item',
      pMeta: '/p-meta/findBySpuId'
    };
    this.spuIdList = new Map();
    this.start = 0;
    // if (!pid && location.origin.indexOf('ahaselected.com') > 0) {
    //   location.href="/";
    //   return;
    // }
    this.pid = pid;
    this.cid = cid;
    this.sortType = sortType;
    this.initList();
  }
  initList () {
    this.customProductList();
    this.observeList();
    this.customProductListPage();
  }
  moneyWithoutDecimals(m) {
    if (typeof m !== 'number') return '0';
    if ((m / 100).toFixed(0) == (m / 100)) return (m / 100).toFixed(0);
    return (m / 100).toFixed(2);
  }
  widthoutDecimals(value) {
    return `<span class="money">$${this.moneyWithoutDecimals(value)}</span>`
  }
  productHmtl(item) {
    let priceHtml = '';
    priceHtml = `<span>${this.widthoutDecimals(item.price)}</span>`;
    if (item.linePrice) {
      priceHtml = `<s class="as-custom-list-price-linePrice">${this.widthoutDecimals(item.linePrice)}</s><span class="as-custom-list-price-sale">${this.widthoutDecimals(item.price)}</span>`
    }
    return `<div class="as-custom-list request-list-item" data-spu="${item.spuId}" data-handle="${item.handle}" data-id="${item.sku}" data-name="${item.title}" data-category="${item.productType}" data-price="${((item.price) / 100).toFixed(2)}" data-compare-to-price="${((item.originalPrice) / 100).toFixed(2)}" data-saleRatio="${item.saleRatio}" data-pubTime="${item.pubTime}">
      <div class="as-custom-list-card ajax-product-img">
        <img src="${item.image}&width=400" />
        <div class="list-label" style="display: none;"><div class="list-lable_tag"></div></div>
        <div class="left_corner_label" style="display: none;"></div>
        <a class="as-custom-list-link request-list-item-link" href="${Shopify.routes.root}products/${item.handle}"></a>
        <a class="product_list_collect grid-view-item__num" href="javascript: void(0);" rel="nofollow"></a>
      </div>
      <div class="as-custom-list-detail">
        <a class="request-list-item-link" href="${Shopify.routes.root}products/${item.handle}">
          <div class="as-custom-list-title">${item.title}</div>
        </a>
        <div class="as-custom-list-price">
          <div class="as-custom-list-left">
            ${priceHtml}
          </div>
          <div class="promotion-activity-code-list"></div>
        </div>
        <div class="ajax-product-color"></div>
      </div>
    </div>`
  }
  configLabel($item, pMeta) {
    const saleratio = $item.data('saleratio');
    const pubtime = $item.data('pubtime');
    if (saleratio) {
      $item.find('.list-lable_tag').addClass('list-lable_sale').text(saleratio);
      $item.find('.list-label').show();
      return;
    }
    if (pubtime && pubtime <= 30) {
      $item.find('.list-lable_tag').addClass('list-label-new').text('NEW');
      $item.find('.list-label').show();
      return;
    }
    const label = pMeta.find((m) => m.type === 'label')?.metaValue;
    if (label) {
      const _label = label.toUpperCase();
      $item.find('.list-lable_tag').addClass(`list-label-${filter_handle(label)}`).text(_label);
      $item.find('.list-label').show();
      return;
    }
  }
  listMetafieldsLabel(list) {
    const $this = this;
    const gridViewItems = $(list).find('.request-list-item');
    if (!gridViewItems.length) return ;
    const spuIdList = [];
    for (const item of gridViewItems) {
      const spuId = item.dataset.spu;
      const sectionId = $(item).parents('.shopify-section').attr('id');
      const key = `${sectionId}_${spuId}`;
      if (!this.spuIdList.has(key) && spuId) {
        spuIdList.push(spuId);
        this.spuIdList.set(key, true);
      }
    }
    if (!spuIdList.length) return;

    AjaxApi(`${this.url.pMeta}`, {
      productIds: spuIdList
    }, "POST").then((res) => {
      const entry = res.entry || {};
      for (const pId of spuIdList) {
        const $item = $(list).find(`.request-list-item[data-spu=${Number(pId)}]`);
        const pMeta = entry[pId] || [];
        if ($item.length > 0) {
          const muscle_Fit = pMeta.find((m) => m.type === 'left_corner_label')?.metaValue;
          if (muscle_Fit) {
            $item.find('.left_corner_label').text(muscle_Fit);
            $item.find('.left_corner_label').show();
          }
          $this.configLabel($item, pMeta);
        }
      }
    });
  }
  observeList() {
    const $this = this;
    const lists = $('.as-custom-lists');
    if (lists.length) {
      for (var list of lists) {
        var observer = new MutationObserver(function (mutations) {
          $this.listMetafieldsLabel(list);
        });
        observer.observe(list, { childList: true });
      }
    }
  }
  createProductList(lists, start) {
    let html = '';
    for (const list of lists) {
      html = html + this.productHmtl(list);
    }
    start === 0 ? $('.as-custom-lists').html(html) : $('.as-custom-lists').append(html);
    productGridSku({ pClass: '.as-custom-lists', products: lists });
  }
  customProductList(start = 0) {
    const $this = this;
    const params = {
        start,
        end: start === 0 ? start + 15 : start + 16,
        tempUserId: $.cookie('as_shopify_id'),
        bytemUid: localStorage.getItem('ahaselected/cly_cookie'),
        platform: screenWidth < 766 ? 'm' : 'pc',
        pid: $this.pid,
        shopId: String(theme.shopId) || ''
    }
    if (this.cid) { params.cid = this.cid; };
    if (this.sortType) { params.sortType = this.sortType; };
    let url = `${this.baseUrl}${this.url.productList}?`;
    const _params = Object.keys(params).map((key) => `${key}=${params[key]}`);
    const _url = url + _params.join('&');
    fetch(_url).then((response) => response.json()).then(({ entry, end, total }) => {
        const lists = (entry || []).map((list) => {
          const locale = Shopify.locale.toUpperCase();
          const pubTime = Math.floor((Date.now() - list.publishedAt) / 86400 / 1000);
          const saleRatio = list.originalPrice - list.price > 0 ? `-${Math.floor((list.originalPrice - list.price) / list.originalPrice * 100)}%` : '';
          const item = {
            ...list,
            title: Shopify.locale == 'en' ? list.title : list[`title${locale}`],
            linePrice: list.originalPrice > list.price ? list.originalPrice : '',
            sku: list.skuVOList && list.skuVOList.length > 0 ? list.skuVOList[0].sku : '',
            pubTime,
            saleRatio
          };
          return item;
        });
        if (start === 0 && lists.length == 0 && location.origin.indexOf('ahaselected.com') > 0) {
          location.href = '/';
          return;
        }
        $this.createProductList(lists, start);
        if (end < total) {
          $this.start = end;
          $('.as-custom-loading').show();
        } else {
          $('.as-custom-loading').remove();
        }
    })
  }
  customProductListPage() {
    const observeNode =  new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.customProductList(this.start);
        }
      });
    }, { threshold: [0],  delay: 0 });
    const as_custom_loading = document.querySelector('.as-custom-loading');
    if (!as_custom_loading) return;
    observeNode.observe(as_custom_loading);
  }
}
if (document.querySelectorAll('.as-custom-page').length === 1) {
  const pid = (location.search.split(/\?|\&/).find((item) => item.indexOf('spuId=') == 0) || '').replace('spuId=','');
  const cid = (location.search.split(/\?|\&/).find((item) => item.indexOf('cid=') == 0) || '').replace('cid=','');
  const sortType = (location.search.split(/\?|\&/).find((item) => item.indexOf('sortType=') == 0) || '').replace('sortType=','');
  new CustomList({ pid, cid, sortType });
}